import {
  findProductVariant,
  getProductFinish,
  getProductVariantSize,
} from '@/app/utils';
import type { Product, ProductVariant } from '@/types/Product';
import { ParsedSku } from '@/utils/parseSku';

export interface ProductData {
  finish: string | undefined;
  product: Product | undefined;
  size: string | undefined;
  variant: ProductVariant | undefined;
}

const findProductDataBySku = (
  products: Product[],
  sku: string | undefined,
): ProductData => {
  // Normalize sku (remove prefix)
  const parsedSku = sku ? new ParsedSku(sku) : null;
  let normalizedSku = sku;
  if (sku?.startsWith('NT')) normalizedSku = parsedSku?.withoutPrefix ?? sku;

  if (!products) {
    return {
      finish: undefined,
      product: undefined,
      size: undefined,
      variant: undefined,
    };
  }

  const product = products.find((product) =>
    product.variants?.some((variant) => variant?.skuCode === normalizedSku),
  );

  const finish = getProductFinish(product!);
  const variant = findProductVariant(product!, normalizedSku);
  const size = getProductVariantSize(variant);

  return {
    finish,
    product,
    size,
    variant,
  };
};

export default findProductDataBySku;
